import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface CreateEmailAlertGroupInterface {
  partnerId?: string
  serviceName?: string
  serviceNameDescription?: string
  tag?: string
  recipientEmails?: string[]
}

export const useCreateEmailAlertGroup = () => {
  const mutate = useMutation(
    ({
      partnerId,
      serviceName,
      serviceNameDescription,
      tag,
      recipientEmails,
    }: CreateEmailAlertGroupInterface) => {
      return postAPI('/NotificationRecipientGroup', {
        group: {
          partnerId: partnerId,
          serviceName: serviceName,
          serviceNameDescription: serviceNameDescription,
          tag: tag,
          recipientEmails: recipientEmails,
        },
      })
    },
  )

  return mutate
}

export default useCreateEmailAlertGroup
